import COLOR from "../../constants/colors";

const styles = {
  paleBackground: {
    background: COLOR.white,
  },
  greenBackground: {
    background: COLOR.green,
  },
  mainArea: {
    // minHeight: "100vh",
    marginTop: 64,
    // marginLeft: 200,
  },
};

export default styles;
